import { usePreserveCallback } from '@teamsparta/react';
import { noop } from '@teamsparta/utils';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { logout } from '@/lib/utils/businessLogics/login/login';
import { useLoginModal } from '@/store/login';

export function useSideBar({
  onClickLogin = noop,
  onClickLogout = noop,
}: {
  onClickLogin?: () => void;
  onClickLogout?: () => void;
}) {
  const preservedOnClickLogin = usePreserveCallback(onClickLogin);
  const preservedOnClickLogout = usePreserveCallback(onClickLogout);

  const loginModal = useLoginModal();
  const router = useRouter();

  const handleClickLogin = useCallback(() => {
    preservedOnClickLogin();

    loginModal.open(router.asPath);
  }, [loginModal, preservedOnClickLogin, router.asPath]);

  const handleClickLogout = useCallback(() => {
    preservedOnClickLogout();

    logout();
  }, [preservedOnClickLogout]);

  return {
    handleClickLogin,
    handleClickLogout,
  };
}

export function useIsCommunityPage() {
  const router = useRouter();
  return router.pathname.includes('/community');
}
